import breakpoints from './breakpoints';

export function findAncestor(el: HTMLElement, cls: string) {
  let currentElement = el.parentElement;
  while (currentElement && !currentElement.classList.contains(cls)) {
    currentElement = currentElement.parentElement;
  }
  return currentElement;
}

export function getCoords(elem: Element | Range) {
  const box = elem.getBoundingClientRect();
  const { body } = document;

  const docEl: HTMLElement = document.documentElement;

  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;

  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

  const clientTop = docEl.clientTop || body.clientTop || 0;

  const clientLeft = docEl.clientLeft || body.clientLeft || 0;

  const top = box.top + scrollTop - clientTop;
  const left = box.left + scrollLeft - clientLeft;

  return { top: Math.round(top), left: Math.round(left) };
}

export function isTouchDevice(): boolean {
  return (
    (window && 'ontouchstart' in window) ||
    (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0)
  ); // works on most browsers && works on IE10/11 and Surface
}

export function setCookie(cname: string, cvalue: string, exdays: string): void {
  const d = new Date();

  const exdaysMs = +exdays * 24 * 60 * 60 * 1000;
  d.setTime(d.getTime() + exdaysMs);
  const expires = d.toUTCString();
  document.cookie = `${cname}=${cvalue};expires=${expires};path=/`;
}

export function getCookie(cname: string): string {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

/**
 * @name parseStringToDom
 * @description Takes a content and transform it in a HTMLElement to give access
 * to DOM Node API
 * @param { HTMLElement | string } content - The content to parse
 * @returns { HTMLElement }
 */
export const parseStringToDom = (
  content: HTMLElement | string,
): HTMLElement => {
  const DOM = document.createElement('div');

  DOM.innerHTML = content as string;
  return DOM;
};

/**
 * Check if the element is a child of another element
 * @param {*} element
 * @param {*} parent
 */

export const isChildrenOf: boolean | any = (
  element: (Node & ParentNode) | null,
  parent: Node,
) => {
  if (!element || !parent) return false;
  if (element === parent) return true;
  if (element.parentNode === parent) return true;
  if (element.parentNode === document) return false;
  if (element.parentNode === document.body) return false;
  return isChildrenOf(element.parentNode, parent);
};

export const createArrayOfTextNodesFromHTML = (container: Element | null) => {
  if (!container) return [];
  const treeWalker = document.createTreeWalker(
    container,
    NodeFilter.SHOW_TEXT,
    null,
    false,
  );

  const nodes = [];
  let nextNode = treeWalker.nextNode();
  // create array of only TEXT_NODE and not empty nodes
  while (nextNode) {
    if (
      nextNode.nodeType === Node.TEXT_NODE &&
      nextNode.textContent &&
      nextNode.textContent.length > 0 &&
      nextNode.textContent.trim() !== ''
    ) {
      nodes.push(nextNode);
    }
    nextNode = treeWalker.nextNode();
  }
  return nodes;
};

/**
 * @name openNewTab
 * @description open window in a new tab insuring security and compatibility for most browsers
 * @param url url to open tab to
 */
export function openNewTab(url: string) {
  const newWindow = window.open();
  if (newWindow) {
    newWindow.opener = null;
    newWindow.location.href = url;
  }
}

export function isTouchDeviceOrSmallScreen() {
  return isTouchDevice() || window.innerWidth < breakpoints.large;
}

export function isElementVisibleInViewport(element: HTMLElement) {
  const { top, bottom, left, right } = element.getBoundingClientRect();
  // Added two pixels in order to support IE11. IE starts at 2,2 (pixels) instead of 0,0.
  return (
    top >= 2 &&
    left >= 2 &&
    bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
